import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import { NeighborhoodOutage } from '@sunrun/component-library/illustrations';
import { Color } from '@sunrun/mui-theme';
import { LIGHT_BLUE_LOGIN_COLOR, DARK_BLUE_LOGIN_COLOR } from '../general/constants/_colors';
import Arrow from '../general/styled/Arrow';
import { LOGIN_HELP_ROUTE, LOGIN_TOS_ROUTE } from '../../constants/routes';
import { MIN_DESKTOP_BREAKPOINT } from '../general/constants/_breakpoints';

const StyledBackButton = styled.div`
  padding: 40px 0 0 25px;
  cursor: pointer;
  max-width: 20px;
`;

const BackHeader = styled.div`
  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    position: absolute;
    top: 0;
    left: 40px;
  }
  position: fixed;
  padding-bottom: 10px;
  z-index: 100;
  width: 100%;
  background-color: inherit;
`;

const GrayBackground = styled.div`
  background-color: ${Color.BLACK_05};

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    position: relative;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`;

const StyledBackground = styled.div`
  position: relative;
  background-image: linear-gradient(${DARK_BLUE_LOGIN_COLOR} 20%, ${LIGHT_BLUE_LOGIN_COLOR} 65%);
  background-color: ${DARK_BLUE_LOGIN_COLOR};
  min-height: 100vh;
  height: auto;
  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    box-sizing: border-box;
    padding: 40px 70px;
  }
`;

const FooterIllustration = styled(NeighborhoodOutage)`
  display: none;
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #03080c;
`;

const Content = styled.div`
  padding-top: 20px;
  overflow-y: auto;
  height: calc(100% - 100px);
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Inter', sans-serif;

  p {
    font-family: 'Inter';
  }
`;

const PasswordlessLoginBackground = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  if (location.pathname === LOGIN_HELP_ROUTE || location.pathname === LOGIN_TOS_ROUTE) {
    return (
      <GrayBackground>
        <BackHeader>
          <StyledBackButton onClick={() => history.goBack()}>
            <Arrow rotation="left" color={Color.BLACK_85} line />
          </StyledBackButton>
        </BackHeader>
        <Content>{children}</Content>
      </GrayBackground>
    );
  }

  return (
    <StyledBackground>
      <Content>{children}</Content>
      <FooterIllustration />
    </StyledBackground>
  );
};

PasswordlessLoginBackground.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PasswordlessLoginBackground;
